export const Default = {
  app: {
    name: "Nutmeg Grove",
    version: "2.0.0",
    description:
      "Nutmeg Grove is a hotel in Galle, that provides comfortable stays to the guests who visit Galle, Sri Lanka.",
    author: "Nutmeg Grove Team",
  },
  color: {
    primaryMain: "#e1d8cd",
    primaryMedium: "#b48966",
    primaryDark: "#5b2e18",

    secondaryMain: "#8b864d",
    secondaryMedium: "#656639",
    secondaryDark: "#45562e",

    tertiaryMain: "#2563EB",
    tertiaryMedium: "#4d90a5",
    tertiaryDark: "#c4bdac",

    error: "#DC2626",
    success: "#10B981",
    warning: "#d1b03b",

    dark: "#000000",
    gray: "#6b6963",
    light: "#FFFFFF",
  },
  header: {
    title: `Nutmeg Grove, Galle : Your Home Away from Home in Paradise`,
    description:
      "Whether you're a backpacker seeking adventure or a comfort seeker yearning for a tranquil retreat, Nutmeg Grove in Galle, Sri Lanka, is the perfect destination. Embrace the charm, indulge in serenity, and create unforgettable memories. Don't wait - book your stay at Nutmeg Grove today and let the magic of Galle captivate you!",
  },
  strings: {
    postButton: "Reserve Now",
    facilitiesButton: "Facilities",
    finePrintButton: "The Fine Print",
    surroundingsButton: "What's Nearby",
  },
  flags: {
    reservationEnabled: true,
  },
  // Property-level information (common to all rooms)
  propertyInfo: {
    description:
      "Nestled in the bustling heart of Galle town on Jail Road, Nutmeg Grove offers a serene escape just minutes away from the historic Galle Fort, Galle railway station, and Galle bus stand. Despite its central location, you'll be amazed at how tranquil and green this minimalistic villa feels. Our comfortable accommodations feature air-conditioned rooms with modern amenities, beautiful garden views, and convenient access to shared living spaces. Hot water facilities and essential comforts ensure a pleasant stay for all our guests. We maintain a relaxed atmosphere while providing the perfect blend of convenience and tranquility at Nutmeg Grove.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.6836085701552!2d80.21143540972972!3d6.038081793922277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae1730054a0da9b%3A0x6d12e87b2f017c9b!2sNutmeg%20Grove!5e0!3m2!1sen!2slk!4v1731661704367!5m2!1sen!2slk",
  },
  // Room categories array - UI will be generated from this
  roomCategories: [
    {
      id: "villa",
      name: "Villa",
      shortDescription: "Entire villa with private garden and full amenities",
      description:
        "The entire villa features a cosy air-conditioned bedroom, a private bathroom with hot water shower, and a comfortable living room. Enjoy modern amenities including a flat-screen TV, refrigerator, air fryer, and private dining area. The villa offers exclusive access to a beautiful private garden and private entrance, comfortably accommodating two people. We have a relaxed smoking policy; however, we kindly request that you smoke in the garden to keep the indoor space fresh.",
      gallery: [
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428979.jpg?k=b8122d817db7c7036303ede3e283429feba15f500eee3c5975d1a3b4a737f07c&o=&hp=1",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428920.jpg?k=1e89be00aeab3c79f45fcd0aeef87d44f6c1540b9bd6367817ee5980f123676e&o=&hp=1",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564429044.jpg?k=ee7baf4ee0c8472f33ade92ff2b807d4377de34b6b1154ba94b9a1f30db90f4a&o=&hp=1",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564429067.jpg?k=6012699cd75d0ce1af8a2fef18a00b72a8e68a5a357f9efec5727c17a0ffc713&o=&hp=1",
        },
        // {
        //   original:
        //     "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428964.jpg?k=3f90015bdb2119677bc7ba1826e3c934ba4b2a22f13cc65e7a47af2d9954788a&o=&hp=1",
        // },
        // {
        //   original:
        //     "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428958.jpg?k=9f0e6a3cc6631e24c3f407e496a2919eb40f4dade9d559a97999410588ebf202&o=&hp=1",
        // },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428952.jpg?k=1e26b379cbceb637083fb44fc934c0f492377c00fbc5a5f9f636b290028e844a&o=&hp=1",
        },
      ],
      featureList: [
        { title: "87 m²", isAvailable: true },
        { title: "1 Air Conditioned Bedroom", isAvailable: true },
        { title: "1 Bathroom", isAvailable: true },
        { title: "Living Room", isAvailable: true },
        { title: "Flat-screen TV", isAvailable: true },
        { title: "Dining Room", isAvailable: true },
        { title: "Air Fryer", isAvailable: true },
        { title: "Refrigerator", isAvailable: true },
        { title: "Hot Water Shower", isAvailable: true },
        { title: "Private Garden", isAvailable: true },
        { title: "Private Entrance", isAvailable: true },
      ],
      pricing: {
        currency: "LKR",
        basePrice: undefined,
        perNight: true,
      },
    },
    {
      id: "deluxe",
      name: "Deluxe",
      shortDescription: "Spacious room with premium amenities",
      description:
        "Our Deluxe room offers a luxurious stay with air conditioning, a comfortable king-sized bed, and access to shared spaces including the garden. Enjoy modern amenities including a flat-screen TV, mini fridge, hot water shower, and beautiful garden views. Perfect for couples seeking comfort and style.",
      gallery: [
        // TODO: Add Deluxe room specific images
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889668764.jpg?k=3ed27eca9dfff4bfe916acd4b4945e5a39cb563ee1ab65b43ee779eec1339392&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889619955.jpg?k=acb189855d215b15d8559506149947bab6eba4cb9daf3e357c2d4164a40dd033&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889619832.jpg?k=70e41dea40c9bcc8c9f40ba49cc018955f5237b504c628b21faec63c50609486&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889668150.jpg?k=ce573ceb64c5e96157d5d85e5b967dbb46bcd35e8c57381686bd94c8833bac33&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889667951.jpg?k=af37fbc5a4a4c350897a595d8bc52bc2c74d117e2807a906b38b674c2442f607&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889667804.jpg?k=be23709bc70f6310700b3bb195d487d8e0ccb1f1b3590bd37da09557809c52fb&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889667684.jpg?k=f87b3a9e55c86a14790b9e93a81286804fea5e18b988ecec8f6dcb4cd324f158&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889667515.jpg?k=20509c5864be44d5e1201ec63c23d232fd7fa62bd3776a82e265af6999256222&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889619788.jpg?k=aff351b45ce707f278597fe6f73c32421e6b0a185acdb559e44d7c38846844fa&o=",
        },
      ],
      featureList: [
        { title: "31 m²", isAvailable: true },
        { title: "1 Air Conditioned Bedroom", isAvailable: true },
        { title: "1 Bathroom", isAvailable: true },
        { title: "Flat-screen TV", isAvailable: true },
        { title: "Mini Fridge", isAvailable: true },
        { title: "Hot Water Shower", isAvailable: true },
        { title: "Garden View", isAvailable: true },
      ],
      pricing: {
        currency: "LKR",
        basePrice: undefined,
        perNight: true,
      },
    },
    {
      id: "junior",
      name: "Junior",
      shortDescription: "Comfortable room with essential amenities",
      description:
        "The Junior room is exactly offering the comfort of deluxe, but slightly smaller in size. It provides a cozy and comfortable space with air conditioning, a private bathroom, hot water shower, and beautiful garden views. Access to shared spaces and the beautiful garden makes this an excellent choice for budget-conscious travelers.",
      gallery: [
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889668150.jpg?k=ce573ceb64c5e96157d5d85e5b967dbb46bcd35e8c57381686bd94c8833bac33&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889669748.jpg?k=b1770b919feef26c0fbf69eaae48496d82b8225268e5b3e51f480defc64a02cc&o=",
        },

        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889670241.jpg?k=4101e09d165641c14c2457074b2aa139f27128682204bf66f25136828228b6d1&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889669509.jpg?k=cc3b8c7ee1c3910a6a14676cda6af8310732b9a0e23e11c549043962cda7af02&o=",
        },

        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889668384.jpg?k=33cacb876f2854eae1a0be390afdab242e3509e08e5c8f4e67b2c5ba046af9e6&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889668257.jpg?k=cce4c171bddb6a6f1f79579a2ff5d85ac552f6463768d7514af49318027f3307&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889667515.jpg?k=20509c5864be44d5e1201ec63c23d232fd7fa62bd3776a82e265af6999256222&o=",
        },
        {
          original:
            "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889620061.jpg?k=d70075ab32ec178e51e10cb8a0e0508d83298d4acee84d8978be48f5bdf20dd2&o=",
        },
      ],
      featureList: [
        { title: "29 m²", isAvailable: true },
        { title: "1 Air Conditioned Bedroom", isAvailable: true },
        { title: "1 Bathroom", isAvailable: true },
        { title: "Flat-screen TV", isAvailable: true },
        { title: "Mini Fridge", isAvailable: true },
        { title: "Hot Water Shower", isAvailable: true },
        { title: "Garden View", isAvailable: true },
      ],
      pricing: {
        currency: "LKR",
        basePrice: undefined,
        perNight: true,
      },
    },
  ],
  gallery: [
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428979.jpg?k=b8122d817db7c7036303ede3e283429feba15f500eee3c5975d1a3b4a737f07c&o=&hp=1",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428920.jpg?k=1e89be00aeab3c79f45fcd0aeef87d44f6c1540b9bd6367817ee5980f123676e&o=&hp=1",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889619955.jpg?k=acb189855d215b15d8559506149947bab6eba4cb9daf3e357c2d4164a40dd033&o=",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889619832.jpg?k=70e41dea40c9bcc8c9f40ba49cc018955f5237b504c628b21faec63c50609486&o=",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564429044.jpg?k=ee7baf4ee0c8472f33ade92ff2b807d4377de34b6b1154ba94b9a1f30db90f4a&o=&hp=1",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889668384.jpg?k=33cacb876f2854eae1a0be390afdab242e3509e08e5c8f4e67b2c5ba046af9e6&o=",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889668257.jpg?k=cce4c171bddb6a6f1f79579a2ff5d85ac552f6463768d7514af49318027f3307&o=",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889667515.jpg?k=20509c5864be44d5e1201ec63c23d232fd7fa62bd3776a82e265af6999256222&o=",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564429067.jpg?k=6012699cd75d0ce1af8a2fef18a00b72a8e68a5a357f9efec5727c17a0ffc713&o=&hp=1",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428964.jpg?k=3f90015bdb2119677bc7ba1826e3c934ba4b2a22f13cc65e7a47af2d9954788a&o=&hp=1",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889669748.jpg?k=b1770b919feef26c0fbf69eaae48496d82b8225268e5b3e51f480defc64a02cc&o=",
    },
    {
      original:
        "https://cf.bstatic.com/xdata/images/hotel/max1024x768/889668764.jpg?k=3ed27eca9dfff4bfe916acd4b4945e5a39cb563ee1ab65b43ee779eec1339392&o=",
    },
    // {
    //   original:
    //     "https://cf.bstatic.com/xdata/images/hotel/max1280x900/564428952.jpg?k=1e26b379cbceb637083fb44fc934c0f492377c00fbc5a5f9f636b290028e844a&o=&hp=1",
    // },
  ],
  featureList: [
    { title: "1 Air Conditioned Bedroom", isAvailable: true },
    { title: "1 Bathroom", isAvailable: true },
    { title: "Living Room", isAvailable: true },
    { title: "Dining Room", isAvailable: true },
    { title: "Hot Water Shower", isAvailable: true },
    { title: "Garden View", isAvailable: true },
    { title: "Private Entrance", isAvailable: true },
  ],

  // Shared facilities across all room types
  facilities: [
    {
      title: "Most Popular Facilities",
      description: [
        "Free WiFi",
        "Family Rooms",
        "Free Parking",
        "Non-smoking Rooms",
        "Private Entrance*",
      ],
      isPinned: true,
    },
    {
      title: "Parking",
      description: ["Free private parking is available on site."],
    },
    {
      title: "Internet",
      description: ["WiFi is available in all areas and is free of charge."],
    },
    {
      title: "Kitchen",
      description: [
        "Electric kettle",
        "Dining table*",
        "Mini Fridge*",
        "Air Fryer*",
      ],
    },
    {
      title: "Bathroom",
      description: [
        "Towels",
        "Private bathroom",
        "Toilet paper",
        "Linen",
        "Toilet",
        "Hairdryer",
        "Hot Water Shower",
      ],
    },
    {
      title: "Living Area",
      description: ["Seating Area", "Dining area*", "Living room / Sofa*"],
    },
    {
      title: "Media & Technology*",
      description: ["Flat-screen TV", "Cable Channels"],
    },
    {
      title: "Room Amenities",
      description: [
        "Socket near the bed",
        "Drying rack for clothing",
        "Clothes rack",
        "Fan",
        "Air conditioning",
        "Private entrance*",
      ],
    },
    {
      title: "Pets",
      description: ["Pets are not allowed."],
    },
    {
      title: "Accessibility",
      description: ["Entire unit located on ground floor"],
    },
    {
      title: "Outdoors",
      description: ["Garden", "Garden View"],
    },
    {
      title: "Food & Drink",
      description: ["Bottled water, Tea/Coffee"],
    },
    {
      title: "Miscellaneous",
      description: ["Family rooms", "Non-smoking rooms"],
    },
    {
      title: "Languages spoken",
      description: ["English", "Sinhala"],
    },
  ],

  reservationOptions: [
    {
      title: "Call Us",
      description: [
        "Reserve your stay directly by calling us at +94778068626.",
      ],
      link: "tel:+94778068626",
      linkLabel: "Call Now",
      icon: "CallIcon",
    },
    {
      title: "Booking.com",
      description: [
        "Book your stay through our official page on Booking.com.",
        "Get access to exclusive deals and offers.",
      ],
      link: "https://www.booking.com/hotel/lk/nutmeg-grove",
      linkLabel: "Reserve Now",
      icon: "LanguageIcon",
    },
    {
      title: "Instagram",
      description: [
        "Send us a direct message on Instagram to make your reservation.",
        "Follow us for updates and offers.",
      ],
      link: "https://www.instagram.com/nutmegvillas",
      linkLabel: "Contact Now",
      icon: "InstagramIcon",
    },
  ],
  finePrintData: [
    {
      title: "Reservation and Payment",
      description: [
        "Please ensure payment is completed as instructed to confirm your reservation.",
      ],
    },
    {
      title: "Check-in",
      description: [
        "From 14:00 to 18:00",
        "Guests are required to show a photo identification and credit card upon check-in.",
        "You'll need to let the property know in advance what time you'll arrive.",
      ],
    },
    {
      title: "Check-out",
      description: ["From 10:00 to 12:00"],
    },
    {
      title: "Check-in Requirements",
      description: [
        "Guests are required to show a photo identification (NIC / Passport) upon check-in.",
        "Guests under the age of 18 can only check in with a parent or official guardian.",
        "Please inform Nutmeg Grove Galle in advance of your expected arrival time to ease the check-in process.",
      ],
    },
    {
      title: "Children and Beds",
      description: [
        "Children of any age are welcome.",
        "To see correct prices and occupancy information, please make sure you have added the correct number of children and their ages in your search.",
        "Cots and extra beds are not available at this property.",
        "There is no age requirement for check-in.",
      ],
    },
    {
      title: "Parties",
      description: ["Parties/events are not allowed."],
    },
    {
      title: "Pets",
      description: ["Pets are not allowed."],
    },
    {
      title: "House Rules",
      description: [
        "For locals, stays of less than 2 nights are not allowed.",
        "A damage deposit may be requested in advance based on the length of stay or accommodation plan.",
        "This property will not accommodate hen, stag, or similar parties.",
        "Pets are not allowed.",
        "Smoking is not allowed inside the rooms.",
      ],
    },
    {
      title: "Cancellation Policy",
      description: [
        "Cancellations made 7 days or more prior to arrival date: Full refund of the deposit.",
        "Cancellations made between 2 and 6 days prior to arrival date: 50% of the deposit will be refunded.",
        "Cancellations made 24 hours or less prior to arrival date, or in case of no-show: No refund.",
      ],
    },
    {
      title: "Additional Information",
      description: [
        "All Special Requests are subject to availability and additional charges may apply.",
      ],
    },
  ],
  neighbourhoodData: [
    {
      title: "Key Attractions",
      items: [
        {
          name: "Galle Fort",
          description:
            "Step back in time as you explore this 17th-century fortification, rich with history and offering stunning views of the Indian Ocean.",
          icon: "FortIcon",
        },
        {
          name: "National Maritime Museum",
          description:
            "Showcases the region's naval history and maritime artifacts.",
          icon: "MuseumIcon",
        },
        {
          name: "Galle Dutch Hospital",
          description:
            "A beautifully restored colonial-era building housing shops, restaurants, and cafes.",
          icon: "RestaurantIcon",
        },
        {
          name: "Galle International Cricket Stadium",
          description:
            "Catch a match at this renowned stadium with a stunning backdrop of the Indian Ocean.",
          icon: "StadiumIcon",
        },
      ],
    },
    {
      title: "Local Delights",
      items: [
        {
          name: "Restaurants and Cafes",
          description:
            "Enjoy a variety of dining options, from local Sri Lankan cuisine to international flavors, including fresh seafood and aromatic curries.",
          icon: "RestaurantIcon",
        },
        {
          name: "Shopping",
          description:
            "Explore shops within the Fort offering handmade crafts, jewelry, stylish clothing, and souvenirs.",
          icon: "StorefrontIcon",
        },
        {
          name: "Cultural Sites",
          description:
            "Visit nearby museums and art galleries to immerse yourself in the rich cultural tapestry of Galle.",
          icon: "MuseumIcon",
        },
      ],
    },
    {
      title: "Scenic Spots",
      items: [
        {
          name: "Beaches",
          description:
            "Unwind on the golden sands of Unawatuna Beach or take a dip in the clear waters of Jungle Beach.",
          icon: "BeachAccessIcon",
        },
        {
          name: "Japanese Peace Pagoda",
          description:
            "Located on Rumassala Hill, this serene pagoda offers breathtaking views and a peaceful atmosphere.",
          icon: "MuseumIcon",
        },
        {
          name: "Rumassala Mountain",
          description:
            "Explore lush greenery and panoramic views from this hill, steeped in local legend.",
          icon: "LocationOnIcon",
        },
        {
          name: "Lighthouse",
          description:
            "The Galle Lighthouse, located within the Fort, is perfect for photography and offers panoramic coastal views.",
          icon: "LocationOnIcon",
        },
      ],
    },
    {
      title: "Convenience and Comfort",
      items: [
        {
          name: "Transport",
          description:
            "With the Galle Bus Stand and Railway Station close by, getting around is a breeze.",
          icon: "DirectionsTransitIcon",
        },
      ],
    },
  ],

  propertySurroundingsData: [
    {
      title: "What's nearby",
      items: [
        "Mahendra Amarasooriya Park - 1 km",
        "Galle Fort National Museum - 1.2 km",
        "Galle Fort Clock Tower - 1.2 km",
        "Little Smile Singithi Uyana - 1.3 km",
        "National Maritime Museum - 1.4 km",
        "Galle Fort - 1.4 km",
        "Galle Lighthouse - 1.9 km",
        "Galle Dadalla Sports Complex - 2.7 km",
        "Sport Ground - 8 km",
        "Parapduwa Nuns Island - 12 km",
      ],
    },
    {
      title: "Restaurants & cafes",
      items: [
        "New Lankan Restaurant - 400 m",
        "New Chinese Restaurant - 200 m",
        "Food Cabin - 650 m",
      ],
    },
    {
      title: "Natural beauty",
      items: [
        "Beekke Reservoir (Lake) - 2.2 km",
        "Kandawattagoda (Forest) - 12 km",
      ],
    },
    {
      title: "Beaches in the neighbourhood",
      items: [
        "Mahamodara Beach - 900 m",
        "Galle Fort Beach - 1.7 km",
        "Lighthouse Beach - 1.9 km",
        "Walawwatta Beach - 3.1 km",
        "Bonavista Beach - 3.5 km",
      ],
    },
    {
      title: "Public transport",
      items: [
        "Galle Railway Station - 700 m",
        "Richmond Hill - 2.9 km",
        "Hikkaduwa Bus Stand - 18 km",
      ],
    },
    {
      title: "Closest airports",
      items: ["Koggala Airport - 14 km"],
    },
  ],
};
